export default __webpack_public_path__ + "static/media/friday.c8031d29.gif";